module.exports = __webpack_public_path__ + "static/img/1-1Z5291A640Y5.3beb2ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5291A640Y5.jpg
// module id = k+oh
// module chunks = 0